module.exports = __webpack_public_path__ + "static/media/salao_atico_1.4c864d1b.jpg";